var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileLargeView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75674 17.2435H10.372C10.55 17.2435 10.6992 17.3041 10.8197 17.4253C10.9401 17.5463 11.0002 17.6963 11.0002 17.8753C11.0002 18.0541 10.9401 18.2029 10.8197 18.3218C10.6992 18.4406 10.55 18.5 10.372 18.5H6.28224C6.06074 18.5 5.87499 18.4251 5.72499 18.2753C5.57516 18.1253 5.50024 17.9395 5.50024 17.718V13.6283C5.50024 13.4503 5.56074 13.301 5.68174 13.1805C5.80291 13.0602 5.95291 13 6.13174 13C6.31074 13 6.45966 13.0602 6.57849 13.1805C6.69733 13.301 6.75674 13.4503 6.75674 13.6283V17.2435ZM17.2437 6.7565H13.6285C13.4505 6.7565 13.3012 6.69592 13.1807 6.57475C13.0604 6.45375 13.0002 6.30375 13.0002 6.12475C13.0002 5.94592 13.0604 5.79708 13.1807 5.67825C13.3012 5.55942 13.4505 5.5 13.6285 5.5H17.7182C17.9397 5.5 18.1255 5.57492 18.2755 5.72475C18.4253 5.87475 18.5002 6.0605 18.5002 6.282V10.3718C18.5002 10.5498 18.4397 10.699 18.3187 10.8195C18.1976 10.9398 18.0476 11 17.8687 11C17.6897 11 17.5408 10.9398 17.422 10.8195C17.3032 10.699 17.2437 10.5498 17.2437 10.3718V6.7565Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLargeView);
export default __webpack_public_path__ + "static/media/file-large-view.9d252f6719d3b230e6b36d2df79dd514.svg";
export { ForwardRef as ReactComponent };